module.exports = __webpack_public_path__ + "assets/images/novasport_6.31da974a0de9f06c557442737b08b027.png";